import client from "./client";


export default {
  getRoles(params) {
    return client.get(`Role`, {params});
  },
  getSchedules(params) {
    return client.get(`Schedule`, {params});
  },
};



// WEBPACK FOOTER //
// ./src/apiServices/adminService.js